<template>
	<div class="my-4 px-4 group-body">
		<div class="group-details" v-if="!notFound">
			<div v-if="showSubGroups" class="sub-groups">
				<GroupsList :groups="groupSubGroups" tableTitle="Sub groups" :hasEditPermissions="canManageGroups" />
			</div>
			<div v-if="showGroupUsers" class="users">
				<GroupUsers :selectedGroup="group" tableTitle="Users" :hasEditPermissions="canManageGroups" />
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import GroupUsers from '@/components/Settings/groups/GroupUsers';
import GroupsList from '@/components/Settings/groups/GroupsList';

import { hasAccountPermission } from '@/store/modules/account/getters';
import { createGroup, updateGroup } from '@/store/modules/accountGroups/actions';
import { groups, defaultGroupName } from '@/store/modules/accountGroups/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';
import { AccountPermissions } from '@ply-io/ply-front-shared-utilities';

export default {
	name: 'GroupMembersTab',
	components: {
		GroupsList,
		GroupUsers,
	},
	props: {
		group: { type: Object },
	},
	computed: {
		...mapGetters([groups.fullPath, defaultGroupName.fullPath]),
		...mapGettersShorthand({ hasAccountPermission }),
		canManageGroups() {
			return this.hasAccountPermission(AccountPermissions.ManageGroups);
		},
		groupsHeigth() {
			const groupsCount = this.groupSubGroups.length;
			return groupsCount === 0 ? 0 : groupsCount > 3 ? 240 : 70 * groupsCount + 40;
		},
		groupUsersHeigth() {
			return this.groupsHeigth === 0 ? 570 : 470 - this.groupsHeigth;
		},
		groupSubGroups() {
			if (!this.group || !this[groups.fullPath]) {
				return [];
			}
			return this[groups.fullPath].filter((x) => this.group.sub_groups.includes(x.id));
		},
		showGroupUsers() {
			return this.group && this.group.users && this.group.users.length > 0;
		},
		showSubGroups() {
			return this.groupSubGroups.length > 0;
		},
	},
	methods: {
		...mapActions([createGroup.fullPath, updateGroup.fullPath]),
	},
	data: () => ({
		searchString: '',
		notFound: false,
	}),
};
</script>

<style scoped lang="scss">
h4.reg {
	font-weight: 500 !important;
}
.group-body {
	height: 370px !important;
	overflow: auto !important;
}
</style>
